import { useMapStore, type MapStyleId } from '@/stores/mapStore'

export interface MapStyleOption {
  id: MapStyleId
  label: string
}

const DEFAULT_STYLES: MapStyleOption[] = [
  { id: 'satellite-streets', label: 'Satellite' },
  { id: 'standard', label: 'Standard' },
  { id: 'light', label: 'Light' },
  { id: 'dark', label: 'Dark' },
]

interface MapStyleSelectorProps {
  styles?: MapStyleOption[]
}

export function MapStyleSelector({ styles = DEFAULT_STYLES }: MapStyleSelectorProps) {
  const { mapStyleId, setMapStyle } = useMapStore()

  return (
    <div className="flex gap-1 rounded-md bg-background/90 p-1 shadow-md backdrop-blur-sm">
      {styles.map((style) => (
        <button
          key={style.id}
          onClick={() => setMapStyle(style.id)}
          className={`rounded px-2 py-1 text-xs font-medium transition-colors ${
            mapStyleId === style.id
              ? 'bg-primary text-primary-foreground'
              : 'hover:bg-muted'
          }`}
        >
          {style.label}
        </button>
      ))}
    </div>
  )
}
